import axios from "axios";

export const axiosInstance = axios.create({
  baseURL: 'https://backend.edit-videos.online.com/function/',
});